import * as yup from "yup"

import * as Controls from "./Controls"
import { isInputableField } from "./helpers"

const numericSchema = yup
  .number()
  .typeError("Please enter a number.")
  .transform((v, o) => (o === "" ? null : v))

const validationSchemas = {
  singleValue: {
    Area: numericSchema,
    Boolean: yup.boolean(),
    Company: yup.mixed(),
    Contact: yup.mixed(),
    InternalContact: yup.mixed(),
    Date: yup.date(),
    Distance: numericSchema,
    Text: yup.string(),
    LegacyRichText: yup.string(),
    RichText: yup.string(),
    Number: numericSchema,
    Money: numericSchema,
    Portfolio: yup.mixed(),
    User: yup.mixed(),
    Lookup: yup.mixed(),
    Length: numericSchema,
    SortProxy: yup.mixed(),
  },
  multipleValues: {
    Company: yup.array(yup.mixed()),
    Portfolio: yup.array(yup.mixed()),
    User: yup.array(yup.mixed()),
    Text: yup.array(yup.string()),
    Lookup: yup.array(yup.mixed()),
    Contact: yup.array(yup.mixed()),
    InternalContact: yup.array(yup.mixed()),
    SortProxy: yup.array(yup.mixed()),
  },
}

const controls = {
  singleValue: {
    Area: Controls.AreaInput,
    Boolean: Controls.CheckBox,
    Company: Controls.CompanyLookup,
    Contact: Controls.ContactLookup,
    InternalContact: Controls.InternalContactLookup,
    Date: Controls.DateInput,
    Distance: Controls.DistanceInput,
    Text: Controls.Input,
    LegacyRichText: Controls.LegacyRichTextInput,
    RichText: Controls.RichTextPreview,
    Number: Controls.Input,
    Money: Controls.MoneyInput,
    Portfolio: Controls.PortfolioLookup,
    User: Controls.UserLookup,
    Lookup: Controls.Select,
    Length: Controls.LengthInput,
    SortProxy: Controls.SingleValueListInput,
  },
  multipleValues: {
    Company: Controls.CompanyLookup,
    Portfolio: Controls.PortfolioLookup,
    User: Controls.UserLookup,
    Text: Controls.ListInput,
    Lookup: Controls.Select,
    Contact: Controls.ContactLookup,
    InternalContact: Controls.InternalContactLookup,
    SortProxy: Controls.ListInput,
  },
}

export function getValidationSchema(fields) {
  return yup.object().shape(
    fields.reduce((obj, field) => {
      if (!isInputableField(field)) return obj

      let fieldSchema =
        validationSchemas[
          field.multiple_values ? "multipleValues" : "singleValue"
        ][field.kind]

      fieldSchema = field.isRequired
        ? fieldSchema.required("Required.")
        : fieldSchema.nullable(true)

      return {
        ...obj,
        [field.key]: fieldSchema,
      }
    }, {})
  )
}

export function getControl(field) {
  //This is the only case where field format determines the control to use,
  //so it doesn't fit nicely into the structure above.
  if (field.format === "Percent") return Controls.PercentageInput
  if (field.format === "Radio") return Controls.Radio

  return controls[field.multiple_values ? "multipleValues" : "singleValue"][
    field.kind
  ]
}
